import React, { useState, useEffect, useContext } from "react";
import ListarPreCalificacionesEscritorio from "./ListarPreCalificacionesEscritorio";
import { Spinner, clienteAxios, AuthContext, useHistory } from "../../shared/";
import Filtro from "../filtro/Filtro";
import { links } from "../../../functions/links";
import apiAxios from "../../../config/ApiAxios";
import "../../shared/styles/ViewContainer.css";

const PreCalificacionesEscritorio = () => {
  const history = useHistory();
  //User data
  const authContext = useContext(AuthContext);
  const { usuario } = authContext;

  const [loadingLocal, setLoadingLocal] = useState(null);
  const [lista, setLista] = useState(null);
  const [mostarFormulario, setMostrarFormulario] = useState(null);
  const [consultar, setConsultar] = useState(true);
  const [Seleccionado, setSeleccionado] = useState(null);
  const [inicio, setInicio] = useState(1);

  const [DatosForm, LeerForm] = useState({
    buscar: "",
    estado: usuario.rol == "Precalificador" ? "Solicitada" : "Todos",
    page: 1,
    paginator: 30,
  });


  const fetch = async (params) => {
    const result = await apiAxios.get("/personas/list", { params });
    setLista(result.data);
    setLoadingLocal(null);
    setConsultar(null);
    setInicio(0);
  };

  useEffect(() => {
    if (!lista) {
      let params = {
        ...DatosForm,
      }
      fetch(params);
    }
  }, [mostarFormulario, consultar, Seleccionado, DatosForm]);

  const onChange = (e) => {
    /*LeerForm({
      ...DatosForm,
      [e.target.name]: e.target.value,
      page: 1,
    });*/

    LeerForm({
      ...DatosForm,
      [e.target.name]: e.target.value,
      page: 1,
    });

    let params = {
      ...DatosForm,
      [e.target.name]: e.target.value,
      page: 1,
    }

    fetch(params);

    //if (buscar.length > 1) {
    //}
    //setConsultar(true);
  };

  const onClick = (e, value) => {
    switch (e.target.name) {
      case "anterior":
        {
          if (DatosForm.page > 1) {
            let params = {
              ...DatosForm,
              page: DatosForm.page - 1,
            }

            LeerForm({
              ...DatosForm,
              page: DatosForm.page - 1,
            });

            fetch(params);
          }
        }
        break;
      case "siguiente":
        {
          if (DatosForm.page < lista.last_page) {
            let params = {
              ...DatosForm,
              page: DatosForm.page + 1,
            }

            LeerForm({
              ...DatosForm,
              page: DatosForm.page + 1,
            });

            fetch(params);
          }
        }
        break;
      case "link":
        {
          let params = {
            ...DatosForm,
            page: value,
          }

          LeerForm({
            ...DatosForm,
            page: value,
          });

          fetch(params);
        }
        break;
      case "ver_credito":
        history.push("/creditos/ver/" + value.id);
        break;
    }
  };

  return (
    <div className="view-container">
      <div className="view-header">
        <h1 className="view-title">Escritorio</h1>
        <div className="view-toolbar">
          <button
            onClick={() => history.push("/clientes/nueva")}
            className="btn-add-primary"
          >
            <i className="bi bi-plus-lg"></i>
            Agregar Cliente
          </button>

          <div className="search-input-container">
            <input
              type="text"
              className="search-input"
              placeholder="Buscar por persona..."
              name="buscar"
              onChange={(e) => onChange(e, null)}
            />
            <i className="bi bi-search search-icon"></i>
          </div>
        </div>
      </div>

      <div className="filter-section">
        <Filtro setForm={LeerForm} form={DatosForm} setConsultar={setConsultar} fetch={fetch} />
      </div>
      {lista ? (
        <div>
          <div className="pagination-container fade-in">
            <div className="pagination-info">
              Total: {lista.total} registros
            </div>
            <div className="pagination-buttons">
              {
                lista.links.map((l, index) => {
                  if (index == 0) {
                    return (
                      <button
                        key={index}
                        className="pagination-btn"
                        name="anterior"
                        onClick={(event) => onClick(event)}
                        disabled={DatosForm.page === 1}
                      >
                        <i className="bi bi-arrow-left"></i>
                      </button>
                    )
                  }

                  if (index == (lista.links.length - 1)) {
                    return (
                      <button
                        key={index}
                        className="pagination-btn"
                        name="siguiente"
                        onClick={(event) => onClick(event)}
                        disabled={DatosForm.page === lista.last_page}
                      >
                        <i className="bi bi-arrow-right"></i>
                      </button>
                    )
                  }

                  return (
                    <button
                      key={index}
                      className={DatosForm.page == l.label ? "pagination-btn pagination-btn-active" : "pagination-btn"}
                      name="link"
                      onClick={(event) => onClick(event, l.label)}
                    >
                      {l.label}
                    </button>
                  )
                })
              }
            </div>
          </div>

          {loadingLocal ? (
            <Spinner />
          ) : (
            <>
              {lista ? (
                <ListarPreCalificacionesEscritorio
                  lista={lista}
                  setSeleccionado={setSeleccionado}
                  setMostrarFormulario={setMostrarFormulario}
                  setConsultar={setConsultar}
                />
              ) : null}
            </>
          )}
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default PreCalificacionesEscritorio;
